<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.34132 8.60299L2.60944 6.13652C1.13024 5.4996 1.13024 3.23919 2.60944 2.60228L8.3471 0.135812C8.7689 -0.0452707 9.23692 -0.0452707 9.65873 0.135812L15.3906 2.60228C16.8698 3.23919 16.8698 5.4996 15.3906 6.13652L9.65873 8.60299C9.22537 8.79031 8.76312 8.78407 8.34132 8.60299ZM8.93274 1.03354C8.97497 1.01242 9.02467 1.01242 9.0669 1.03353L11.7316 2.36571C11.8422 2.42099 11.8422 2.57876 11.7317 2.63405L9.0669 3.96646C9.02467 3.98757 8.97496 3.98757 8.93273 3.96645L6.2683 2.63404C6.15775 2.57876 6.15776 2.42099 6.26831 2.36572L8.93274 1.03354ZM9.0669 4.53353C9.02467 4.51242 8.97497 4.51242 8.93274 4.53354L6.26831 5.86572C6.15776 5.92099 6.15775 6.07876 6.2683 6.13404L8.93273 7.46645C8.97496 7.48757 9.02467 7.48757 9.06691 7.46646L11.7317 6.13405C11.8422 6.07876 11.8422 5.92099 11.7316 5.86571L9.0669 4.53353Z"
    />
    <path
      d="M15.8185 7.79137C15.8358 7.78547 15.8647 7.76776 15.8647 7.76776C16.847 8.58247 16.691 10.2946 15.3909 10.8259L9.65875 13.1579C9.22538 13.335 8.76311 13.3291 8.34129 13.1579L2.60917 10.8259C1.30904 10.3005 1.15302 8.58838 2.13534 7.76776C2.15268 7.77366 2.18157 7.79137 2.18157 7.79137L7.91369 10.1234C8.61287 10.4067 9.38717 10.4067 10.0864 10.1234L15.8185 7.79137Z"
    />
    <path
      d="M15.8623 12.0192C15.8623 12.0192 15.8335 12.0384 15.8161 12.0448L10.0849 14.5711C9.38586 14.8781 8.61168 14.8781 7.91262 14.5711L2.18142 12.0448C2.18142 12.0448 2.15253 12.0256 2.1352 12.0192C1.15304 12.9018 1.30903 14.763 2.60895 15.3322L8.34015 17.8585C8.7619 18.044 9.22409 18.0504 9.6574 17.8585L15.3886 15.3322C16.6885 14.7566 16.8503 12.9018 15.8623 12.0192Z"
    />
  </svg>
</template>
